/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/list'
export default icon
